import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { searchRespondents } from '../../../../../services/apps/RespondentServices';
import { getRespondentsFromJPS } from '../../../../../utils/JobProfileUtil';
import HintsJPSAddForm from './HintsJPSAddForm';
import { withGrowl } from '../../../../../components/GrowlNotifications';
import { growlErrors } from '../../../../../utils/NotificationUtil';
import { withAccount } from '../../../../../components/AccountContext';
import { matchShape, growlShape, intlShape } from '../../../../../components/prop-types';
import { validationMessages } from '../../../../../i18n/common';

const buildValidationSchema = formatMessage => (Yup.object().shape({
  firstName: Yup.string().when('respondent', {
    is: value => !(value),
    then: () => Yup
      .string()
      .required(formatMessage(validationMessages.required)),
  }),
  lastName: Yup.string().when('respondent', {
    is: value => !(value),
    then: () => Yup
      .string()
      .required(formatMessage(validationMessages.required)),
  }),
  email: Yup.string().when('respondent', {
    is: value => !(value),
    then: () => Yup
      .string()
      .email(formatMessage(validationMessages.invalidEmail))
      .required(formatMessage(validationMessages.required)),
  }),
  locale: Yup.string().when('respondent', {
    is: value => !(value),
    then: () => Yup
      .string()
      .required(formatMessage(validationMessages.required)),
  }),
  gender: Yup.string().when('respondent', {
    is: value => !(value),
    then: () => Yup
      .string()
      .required(formatMessage(validationMessages.required)),
  }),
}));

class HintsJPSAddFormContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      respondentList: [],
      loadingRespondents: false,
    };

    this.searchRespondent = this.searchRespondent.bind(this);
  }

  componentDidMount() {
    this.fetchRespondents();
  }

  searchRespondent(query) {
    this.fetchRespondents(query);
  }

  async fetchRespondents(query) {
    const { match, growl } = this.props;
    this.setState({ loadingRespondents: true });
    try {
      const { aid } = match.params;
      const data = await searchRespondents({
        aid,
        query,
      });

      this.setState({
        respondentList: data,
        loadingRespondents: false,
      });
    } catch (errors) {
      growlErrors(growl, errors);
      this.setState({ loadingRespondents: false });
    }
  }

  render() {
    const {
      jobProfileSurveys, activeLocales, intl: { formatMessage },
      onAdd,
    } = this.props;
    const { locale, onCancel } = this.props;
    const { respondentList, loadingRespondents } = this.state;
    const jpsRespondents = getRespondentsFromJPS(jobProfileSurveys);
    const initialValues = {
      firstName: '',
      lastName: '',
      email: '',
      locale,
      gender: '',
    };

    const validationSchema = buildValidationSchema(formatMessage);
    return (
      <div className="panel-body double-bordered">
        <Formik
          onSubmit={onAdd}
          validationSchema={validationSchema}
          initialValues={initialValues}
          render={formProps => (
            <HintsJPSAddForm
              formProps={formProps}
              onCancel={onCancel}
              respondentList={respondentList}
              loadingRespondents={loadingRespondents}
              searchRespondent={this.searchRespondent}
              jpsRespondents={jpsRespondents}
              activeLocales={activeLocales}
            />
          )}
        />
      </div>
    );
  }
}

HintsJPSAddFormContainer.propTypes = {
  match: matchShape.isRequired,
  growl: growlShape.isRequired,
  jobProfileSurveys: PropTypes.arrayOf(PropTypes.any).isRequired,
  activeLocales: PropTypes.arrayOf(PropTypes.any).isRequired,
  intl: intlShape.isRequired,
  onAdd: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  locale: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => {
  const { translatedTags, locale } = state.i18n;
  return {
    addJPSRespondentFormValues: getFormValues('addJPSRespondent')(state),
    activeLocales: translatedTags,
    locale,
  };
};

export default withAccount(
  withGrowl(
    withRouter(
      injectIntl(
        connect(
          mapStateToProps,
        )(HintsJPSAddFormContainer),
      ),
    ),
  ),
);
